module.exports = __webpack_public_path__ + "img/bg_exchange@2x.afd5c95c.png";